
import './App.css';
import Home from "./pages/Home";
import About from "./pages/About";
import MyWorks from './pages/MyWorks';
import Portrait from './pages/Portrait';
import Concert from './pages/Concert';
import Travel from './pages/Travel';
import Wedding from './pages/Wedding';
import Activity from './pages/Activity';
import NoMatch from './pages/NoMatch';
import {Routes, Route} from "react-router-dom";
import React, { useState, useEffect} from 'react';
import NavBar from './components/NavBar';
import AdminLoginPage from './components/AdminLoginPage';
import EventDetail from './pages/EventDetail';
const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000/api';
function App() {

  const [userRole, setUserRole] = useState('user'); // or 'admin'
  const [isPreviewMode, setIsPreviewMode] = useState(false); // Controls the view
  
  useEffect(() => {
    async function verifyToken(){
      try{
        const token = localStorage.getItem('adminToken');
        const response = await fetch(`${API_URL}/verify-token`, {
          method: 'GET',
          headers: {
              'Authorization': `Bearer ${token}`, // This is the standard format
              'Content-Type': 'application/json'
          }
        });
        if (response.ok){
          const data = await response.json()
          if (data.authenticated){
            setUserRole('admin');
          }
        }
      }catch(error){
        console.error("Network error:", error);
        // alert("Could not connect to the server");
        // alert(error.message);
      }
      
    };
    verifyToken();
  }, []);

  return (
    <div> 
      {userRole === 'admin' && (
                <div className="text-center my-3 admin-button">
                    <button
                        className="btn btn-info"
                        onClick={() => setIsPreviewMode(!isPreviewMode)}
                    >
                        {isPreviewMode ? 'Exit Preview Mode' : 'Preview User View'}
                    </button>
                </div>
        )}
      <NavBar/> 
      <main className="main-content ">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portrait/:subcategory" element={<Portrait userRole={userRole} isPreviewMode={isPreviewMode}/>} />
          <Route path="/wedding/:subcategory" element={<Wedding userRole={userRole} isPreviewMode={isPreviewMode}/>} />
          <Route path="/activity/:subcategory" element={<Activity userRole={userRole} isPreviewMode={isPreviewMode}/>} />
          <Route path="/concert" element={<Concert userRole={userRole} isPreviewMode={isPreviewMode}/>} />
          <Route path="/travel/:subcategory" element={<Travel userRole={userRole} isPreviewMode={isPreviewMode}/>}/>

          <Route path="/portrait/:subcategory/:id" element={<EventDetail pageCategory={`portrait`} userRole={userRole} isPreviewMode={isPreviewMode}/>} />
          <Route path="/wedding/:subcategory/:id" element={<EventDetail pageCategory={`wedding`} userRole={userRole} isPreviewMode={isPreviewMode}/>} />
          <Route path="/activity/:subcategory/:id" element={<EventDetail pageCategory={`activity`} userRole={userRole} isPreviewMode={isPreviewMode}/>} />
          <Route path="/concert/:id" element={<EventDetail pageCategory="concert" userRole={userRole} isPreviewMode={isPreviewMode}/>} />
          <Route path="/travel/:subcategory/:id" element={<EventDetail pageCategory={`travel`} userRole={userRole} isPreviewMode={isPreviewMode}/>}/>
          
          <Route path="/myworks" element={<MyWorks userRole={userRole} isPreviewMode={isPreviewMode}/>} />
          <Route path="/about" element={<About />} />
          <Route path="*" element={<NoMatch/>} />
          <Route path="/tiansphotography0905-login" element={<AdminLoginPage setUserRole={setUserRole}/>} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
